import { Link, redirect, useNavigation } from "react-router-dom";
import AuthForm from "../../../components/AuthForm";

import { API_BASE_URL } from "../../../config";

import "./LoginRegister.css";

const fields = [
  {
    label: "Email",
    type: "email",
    placeholder: "example@email.com",
    name: "email",
  },
  {
    label: "Password",
    type: "password",
    placeholder: "",
    name: "password",
  },
];

export default function Login() {
  const navigation = useNavigation();

  const isSubmitting = navigation.state === "submitting";

  return (
    <section id="login_register">
      <AuthForm
        method="POST"
        title="Login"
        fields={fields}
        buttonText={isSubmitting ? "Logging in..." : "Login"}
        googleButtonText="Login via Google"
      >
        <div className="form-auth-message">
          <div className="form-auth-message__text">
            <Link to="/forgot-password">Forgot Password</Link>
          </div>
        </div>
      </AuthForm>
    </section>
  );
}

export const loginAction = async ({ request }) => {
  const formData = await request.formData();

  const data = {
    email: formData.get("email"),
    password: formData.get("password"),
  };

  const response = await fetch(`${API_BASE_URL}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (result.success === false) {
    return { error: result.message || "Login failed. Please try again." };
  }

  localStorage.setItem("token", result.token);
  localStorage.setItem("approved", result.approved);
  localStorage.setItem("role", result.role);
  localStorage.setItem("id", result.id);
  localStorage.setItem("avatar", result.avatar);
  localStorage.setItem("login_time", Date.now());

  if (result.role === "employee") {
    if (result.approved === 0) {
      return redirect("/professionals-approval");
    } else if (result.approved === 2) {
      return redirect(`/my-profile/${result.id}`);
    }
  }

  if (result.role === "company") {
    if (result.approved === 0) {
      return redirect("/company-approval");
    } else if (result.approved === 1) {
      return redirect("/company-under-review");
    } else if (result.approved === 2) {
      return redirect("/my-jobs");
    }
  }
};
